import AddButton from "components/Button/AddButton";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DropdownStatusList, EmptyString, FormTypeAdd, PageSize, StatusCodeActive } from "utils/Constant";
import Dropdown from "components/Input/Dropdown";
import { GetStatus } from "utils/helpers";
import { useModal } from "utils/context/ModalContext";
import { BankService } from "services/BankService/BankService";
import { FilterCard, GridDeleteButton, GridEditButton, GridRevisionButton, MainBodyCard } from "components/Cards";
import Pagination from "components/Input/PaginationButton";
import DataTable from "components/DataTable";

export default function Bank(){
    let navigate = useNavigate()

    const firstLoad = useRef(false)
    const debounceRef = useRef(null)

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()

    const { fetchBankList, fetchDeleteBank } = BankService()

    const [bankList, setBankList] = useState([])
    const [bankCode, setBankCode] = useState(EmptyString)
    const [bankName, setBankName] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    const columns = [
        {
            key: "rowNumber",
            header: "No",
            headerClassName: "w-16 font-semibold",
            cellClassName: "text-center"
        },
        {
            key: "bankCode",
            header: "Kode Bank"
        },
        {
            key: "bankName",
            header: "Nama Bank"
        },
        {
            key: "callCenter",
            header: "Call Center",
        },
        {
            key: "status",
            header: "Status",
            render: (row) => GetStatus(row.status),
        },
        {
            key: "action",
            header: "Action",
            render: (row) => (
                <div className="flex gap-2">
                    <GridEditButton isActive={row.status} onClick={() => editBtnClick(row.bankId)} size="w-3" />
                    <GridDeleteButton isActive={row.status} onClick={() => deleteBtnClick(row.bankId, row.status)} size="w-3" />
                </div>
            ),
        },
    ]

    const addBtnClick = () => { navigate("/setting/bank/form?bankId=&formType=" + FormTypeAdd) }

    async function handlePageChange(newIndex) {
        try {
            showLoading()

            const res = await fetchBankList(
                bankCode,
                bankName, 
                status,
                PageSize,
                parseInt(pageIndex)
            )

            if (!res) return

            const totalData = res?.data?.totalData ?? 0;
            const total = Math.max(1, Math.ceil(totalData / PageSize));

            setBankList(res)
            setTotalPages(total)
            setPageIndex(newIndex)
        } finally {
            hideLoading()
        }
    }

    // Function Button
    const editBtnClick = (bankId) => {
        navigate("/setting/bank/form?bankId=" + bankId + "&formType=Edit")
    }
    const deleteBtnClick = async (bankId, status) => {
        const isConfirmed = await confirm()

        if (!isConfirmed) return 

        showLoading()
        
        try {
            const res = await fetchDeleteBank(bankId, status)
            if (!res) return
        }
        finally {
            hideLoading()
            showSuccess({
                onSuccess: () => {
                    handlePageChange(pageIndex)
                }
            })
        }
    }

    useEffect(() => {
        const onLoad = async () => {
            if (firstLoad.current) {
                handlePageChange(0)

                firstLoad.current = false
            } 
            else {
                if (debounceRef.current) {
                    clearTimeout(debounceRef.current)
                }
        
                debounceRef.current = setTimeout(() => {
                    handlePageChange(0)
                }, 500)
            }
        }

        onLoad()
    },[bankCode, bankName, status])

    return(
        <MainBodyCard>
            <div >
                <span className="font-semibold text-2xl">Bank</span>
            </div>  
            <hr />

            <div className="flex flex-col sm:flex-row gap-5 mt-5">
                <FilterCard title='Bank Code'>
                    <input className="input" value={bankCode} onChange={(e) => setBankCode(e.target.value.toUpperCase())} />
                </FilterCard>
                <FilterCard title='Bank Name'>
                    <input className="input" value={bankName} onChange={(e) => setBankName(e.target.value.toUpperCase())} />
                </FilterCard>
                <FilterCard title='Status' width={'w-32'}>
                    <Dropdown className='w-full' value={status} options={DropdownStatusList} onChange={(e) => setStatus(e.value)} placeholder={"All"} />
                </FilterCard>
            </div>

            <div className="flex w-full justify-end">
                <AddButton onClick={addBtnClick} title='Tambah Bank' />
            </div>
           
            <div className="mt-5">
                <DataTable
                    columns={columns}
                    data={bankList?.data?.listData ?? []}
                />
            </div>

            <Pagination pageIndex={pageIndex} totalPages={totalPages} onPageChange={handlePageChange} />
        </MainBodyCard>
    )
}